<template>
  <div class="ai-friend-role-tag">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @add="add" @edit="edit" @delete="deleteRow"></ConfigTable>
    <EditCost ref="editDialog" @sure="callEdit"></EditCost>
  </div>
</template>

<script>
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import aiFriendApi from '../../../api/aiFriendManage';
import EditCost from './components/EditCost.vue';

const searchConfig = [
  // { type: 'select', placeholder: '选择App', key: 'appId', options: appOptions },
  // { type: 'daterange', startPlaceholder: '选择开始日期', endPlaceholder: '选择结束日期', key: 'sDate', keys: ['sDate', 'eDate'] },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
]

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '模型名称', key: 'modelName' },
  { name: '分组倍率', key: 'groupMillion' },
  { name: '提示倍率', key: 'promptMillion' },
  { name: '完成倍率', key: 'completionMillion' },
  { name: '提示词价格 $', key: 'promptCost' },
  { name: '完成词价格 $', key: 'completionCost' },
  { name: '模型倍率', key: 'modelMillion' },
  { name: '充值倍率', key: 'rechargeMillion' },
  { name: '用户折扣', key: 'userMillion' },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiFriendCost',
  components: { ConfigTable, EditCost },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      const ps = { ...params }
      try {
        const r = await aiFriendApi.getCostList(ps)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai角色标签失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await aiFriendApi.delCost({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit ? aiFriendApi.updateCost(r.data) : aiFriendApi.createCost(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {
        console.error('call edit error:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-role-tag {

  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>